import React, { useState } from 'react';
import '../App.css'; // Ensure the path is correct

const StudentForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        contact: '',
        education: '',
        state: '',
        city: '',
    });
    const [responseMessage, setResponseMessage] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = ({ target: { name, value } }) => {
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Basic validation for all fields
        if (
            !formData.name ||
            !formData.email ||
            !formData.contact ||
            !formData.education ||
            !formData.state ||
            !formData.city
        ) {
            setResponseMessage('All fields are required.');
            setIsSuccess(false);
            return;
        }

        setIsSubmitting(true);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/submit-student-form`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });

            const data = await response.json();

            if (response.ok) {
                setResponseMessage(data.message || 'Form submitted successfully! We will contact you soon.');
                setIsSuccess(true);
                setFormData({
                    name: '',
                    email: '',
                    contact: '',
                    education: '',
                    state: '',
                    city: '',
                });
            } else {
                throw new Error(data.message || 'Unexpected error occurred.');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            setResponseMessage('Error submitting form. Please try again later.');
            setIsSuccess(false);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="form-container">
            <h2>🎓 Join the Full Stack Development Course</h2>
            <form onSubmit={handleSubmit}>
                <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                />
                <input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                />
                <input
                    type="text"
                    name="contact"
                    placeholder="Your Contact Number"
                    value={formData.contact}
                    onChange={handleChange}
                    required
                />
                <input
                    type="text"
                    name="education"
                    placeholder="Your Education Qualification"
                    value={formData.education}
                    onChange={handleChange}
                    required
                />
                <input
                    type="text"
                    name="state"
                    placeholder="Your State"
                    value={formData.state}
                    onChange={handleChange}
                    required
                />
                <input
                    type="text"
                    name="city"
                    placeholder="Your City"
                    value={formData.city}
                    onChange={handleChange}
                    required
                />
                <button type="submit" disabled={isSubmitting}>
                    {isSubmitting ? 'Submitting...' : 'Submit'}
                </button>
            </form>
            {responseMessage && (
                <p
                    style={{
                        color: isSuccess ? 'green' : 'red',
                        marginTop: '10px',
                        fontWeight: 'bold',
                    }}
                >
                    {responseMessage}
                </p>
            )}
        </div>
    );
};

export default StudentForm;
